var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebookLogin = function SvgFacebookLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22.854
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18636",
    d: "M23 11.5a11.5 11.5 0 0 1-9.7 11.357V14.82h2.68l.51-3.323H13.3V9.34a1.662 1.662 0 0 1 1.874-1.8h1.45V4.716a17.693 17.693 0 0 0-2.574-.225c-2.63 0-4.35 1.592-4.35 4.473V11.5H6.783v3.32H9.7v8.034A11.5 11.5 0 1 1 23 11.5Z",
    fill: "#3b8df7"
  })));
};
export default SvgFacebookLogin;